import { convertDate } from '../../helpers/utilityFunctions/utilityFunctions';
import { ActiveState } from '../../model/active/ActiveState';
import {
  CLEAR_ACTIVE_TEST_DATA,
  CLEAR_ACTIVE_TEST_DATE,
  CLEAR_ACTIVE_TEST_DATES,
  FETCH_ACTIVE_OVERVIEW_SUCCESS,
  FETCH_ACTIVE_TEST_DATA_SUCCESS,
  FETCH_ACTIVE_TEST_DATES_SUCCESS,
  SELECT_ACTIVE_TEST_DATE,
} from '../constants';
import { initialState } from '../system/SystemState';
import { ActiveActionTypes } from '../types/activeActionTypes';

export default function patientReducer(
  state = initialState.active,
  action: ActiveActionTypes
): ActiveState {
  switch (action.type) {
    case FETCH_ACTIVE_OVERVIEW_SUCCESS:
      return {
        ...state,
        overview: action.payload,
      };
    case FETCH_ACTIVE_TEST_DATES_SUCCESS:
      return {
        ...state,
        dates: action.payload,
      };
    case FETCH_ACTIVE_TEST_DATA_SUCCESS: {
      // Discard stale / out-of-order responses: only accept data for the date
      // that is currently selected. Rapidly changing days fires several
      // requests whose responses can resolve out of order; without this guard
      // a slow response for a previous day can overwrite the current day's
      // data (stale list) or a cleared table (data that never loads).
      // A missing action.date keeps the previous, unguarded behaviour.
      if (
        action.date !== undefined &&
        (state.selectedDate == null ||
          convertDate(new Date(state.selectedDate)) !== action.date)
      ) {
        return state;
      }
      return {
        ...state,
        selectedActiveTestData: action.payload,
      };
    }

    case SELECT_ACTIVE_TEST_DATE:
      return {
        ...state,
        selectedDate: action.payload,
      };

    case CLEAR_ACTIVE_TEST_DATE:
      return {
        ...state,
        selectedDate: null,
      };

    case CLEAR_ACTIVE_TEST_DATES:
      return {
        ...state,
        dates: [],
      };

    case CLEAR_ACTIVE_TEST_DATA:
      return {
        ...state,
        selectedActiveTestData: [],
      };

    default:
      return state;
  }
}
